<ion-card class="mea-page-description ion-no-margin">
  <ion-card-header class="ion-no-border">
    <ion-toolbar>
        <ion-buttons *ngIf="!isHome">
            <ion-back-button
                defaultHref="home"
                [text]="'GLOBAL_BACK_TEXT' | translate">
            </ion-back-button>
        </ion-buttons>
        <ion-card-title *ngIf="!isHome" [innerHTML]="cardTitle"></ion-card-title>
    </ion-toolbar>
  </ion-card-header>

  <ion-card-content>
        <div [innerHTML]="cardHeadline"></div>
        <ng-container *ngIf="cardLinkUrl">
            <ion-button [href]="cardLinkUrl" type="link" color="tertiary" expand="inline-block" class="ion-margin-vertical"
                size="large">
                <span [innerHtml]="cardLinkText"></span>
            </ion-button>
        </ng-container>
  </ion-card-content>

</ion-card>
